<template>
    <v-row class='justify-center'>
        <v-col lg=3 md=12>
            <v-card min-height='300' class='pa-10' color='#fbfbfb'>
                <v-card-title><h2>Signup</h2></v-card-title>
                <v-card-text>
                     <v-form class='pb-3' ref="form">
                        <v-text-field :rules="[rules.required]" solo v-model="name" dense label='Name' name='name'></v-text-field>
                        <v-text-field :rules="[rules.required]" solo v-model="email" dense label='Email'></v-text-field>
                        <v-text-field :rules="[rules.required]" solo v-model="password" dense type='password' label='Password'></v-text-field>
                        <v-text-field :rules="[rules.required]" solo v-model="confirm_password" dense type='password' label='Confirm Password'></v-text-field>
                        <v-btn @click="userSignup" color='primary'>Signup</v-btn>
                    </v-form>
                </v-card-text>
               

                <p class='text-center'>Already Signed up?</p>
                <a @click="$router.push({ path: '/' })"><p class='text-center'>Login</p></a>
            </v-card>
        </v-col>
    </v-row>
  
</template>
<script>
/*global myBaseURL*/

import axios from 'axios';

export default {
    name: 'Signup',
    data() {
        return {
            name: '',
            email: '',
            password: '',
            confirm_password: '',
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
        }
    },
    methods : ({
        userSignup(){
            if(this.$refs.form.validate())
            {
                if(this.password == this.confirm_password)
                {
                    var that = this;
                    axios.request({
                        url: '/seller/registration',
                        method: 'POST',
                        baseURL: myBaseURL,
                        data : {
                            name : that.name,
                            email : that.email,
                            password : that.password
                        }
                    }).then(response => {
                        console.log(response.data.access_token);
                        localStorage.setItem('access_token', response.data['access_token']);
                        that.$router.push({ path: '/addStore' });
                        console.log('Submit Success')
                    }).catch(e => {
                        console.log(e);
                        console.log('Submit Fail')
                    });
                    console.log('done');
                }
                else
                {
                    console.log('Both passwords do not match.');
                }
            }
        }
    })
}
</script>